import { render, staticRenderFns } from "./AddInstallment.vue?vue&type=template&id=8236881c&"
import script from "./AddInstallment.vue?vue&type=script&lang=js&"
export * from "./AddInstallment.vue?vue&type=script&lang=js&"
import style0 from "./AddInstallment.vue?vue&type=style&index=0&id=8236881c&prod&lang=css&"
import style1 from "./AddInstallment.vue?vue&type=style&index=1&id=8236881c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports